<template>
  <van-action-sheet v-model="visible" title="缴纳预报名费" class="fixedapp">
    <van-form class="pay-form" @submit="submitPay2">
      <van-cell title="支付方式">
        <div>
          微信支付
        </div>
      </van-cell>
      <van-cell title="选择费用">
        <div slot="label" style="display:flex; flex-wrap:wrap;">
          <van-loading v-if="feesLoading" />
          <template v-for="(item, index) in moneys">
            <a :key="item" href="javascript:;"
              style="display:flex; align-items:center; margin:6px 10px 6px 0; font-size:1.5rem; border:1px #ccc solid; border-radius:5px;"
              :style="index == currentMoney ? 'color:#fff; background-color:#7232dd; border-color:#7232dd;' : 'color:#888; background-color:#f5f5f5;'"
              @click="currentMoney = index"
            >
              <span style="padding:5px 10px;">{{ item }}</span>
            </a>
          </template>
        </div>
      </van-cell>
      <div class="signup-btns">
        <van-button round block type="info" native-type="submit" :loading="saveLoading" loading-text="支付中...">
          确定支付
        </van-button>
      </div>
    </van-form>
  </van-action-sheet>
</template>
<script>
import siteMixin from '@/utils/site-mixin';
import { deepCopy } from '@/utils/utils';
export default {
  name: 'FeeCyj',
  mixins: [siteMixin],
  props: {
    roll: Object
  },
  data () {
    return {
      visible: false,
      saveLoading: false,
      currentMoney: 0,
      feesLoading: false,
      defaultFees: [100,200,300,400,500],
      moneys: []
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadFees();
      }
    }
  },
  methods: {
    show(val) {
      this.visible = val ? true : false;
    },
    loadFees() {
      this.feesLoading = true;
      this.moneys = [];
      this.doGet({
        url: 'site/fee/loadFees',
        okcb: (json) => {
          this.moneys = json || [];
          if (!this.moneys.length) {
            this.moneys = this.defaultFees;
          }
        },
        cb: () => {
          this.feesLoading = false;
        },
        errcb: () => {
          this.moneys = this.defaultFees;
        }
      });
    },
    submitPay2() {
      const money = this.moneys[this.currentMoney];
      let postData = deepCopy(this.roll);

      postData.amount = money * 100;
      postData.jfname = '预报名费';
      postData.openid = this.member.openid;
      postData.paymethod = 'WX';
      postData._member = {id:this.member.id};
      postData.version === null ? postData.version = 1 : (postData.version += 1);

      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });

      this.saveLoading = true;
      this.doPost({
        url: 'site/fee/submit',
        data: postData,
        okcb: (json) => {
          // 如果需要公众号openid
          if (json.needopenid) {
            setTimeout(() => {
              this.login();
            }, 100);
            return;
          }

          let params = { goods: {name: this.roll.xjname, amount: money * 100}, orderid: this.roll.stuid };
          if (json.code_url) {
            params.codeUrl = json.code_url;
          } else {
            params.wxpayparams = JSON.parse(json.payparams);
          }
          // 支付界面
          this.$router.push({ name:'signup-pay', params: params });
        },
        cb: () => {
          this.saveLoading = false;
          this.Toast.clear();
        },
        errcb: (json) => {
          if (json && json.message) {
            setTimeout(() => {
              this.Toast.fail(json.message);
            }, 10);
          }
        }
      });
    },
  }
}
</script>